<template>
    <div class="type">
     <div class="FilesAndPicturesBox">
      <FilesAndPictures :DelFlag="false" v-for="(item , index) of PicTypeRejectListProps.lstAttachment" :key="index" :fileAddImgData="item" @See="See"></FilesAndPictures>
    </div>
  </div>
</template>

<script>
import FilesAndPictures from '@/components/FilesAndPictures.vue'
  export default {
    components:{
        FilesAndPictures
    },
    props:{
        PicTypeRejectListProps: {
            type: Object
        }
    },
    data(){
      return {
          
      }
    },
    created(){},
    mounted(){},
    activated(){},
    updated(){},
    methods:{
        See(URL){
            this.$emit('See',URL)
        }
    },
    computed:{},
    watch:{},
  }
</script>
<style scoped lang='less'>
@import url('../index.less');

.FilesAndPicturesBox {
  width: 101%;
  // height: 500px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
</style>